import { webHooksHandlers } from './webhooksHandlers';

export const handlers = [...webHooksHandlers];
